import { useEffect, useState } from "react";
import { api } from "@/lib/app";

/**
 * Small pill in the header showing which TiDo environment the backend is
 * pointing at. Renders nothing until `/api/tido/config` responds and
 * `env_label` is non-empty.
 *
 * Colors:
 *   - "test"/"dev"  → amber pill  (visual reminder we're on a test tenant)
 *   - "prod"        → green pill
 *   - anything else → neutral gray
 */
export default function TidoEnvBadge() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/tido/config").then(({ data }) => setCfg(data)).catch(() => setCfg(null));
  }, []);

  if (!cfg || !cfg.env_label) return null;

  const label = cfg.env_label.toUpperCase();
  const isProd = cfg.env_label === "prod" || cfg.env_label === "production";
  const isTest = ["test", "dev", "staging", "preview"].includes(cfg.env_label);

  const cls = isProd
    ? "bg-[var(--success-bg)] text-[var(--success)] border-[var(--success)]/30"
    : isTest
    ? "bg-[var(--warning-bg)] text-[var(--warning)] border-[var(--warning)]/40"
    : "bg-[var(--bg-surface-hover)] text-[var(--text-secondary)] border-[var(--border-default)]";

  return (
    <div
      className={`px-2 py-1 rounded-md text-[10px] font-bold tracking-wider border ${cls}`}
      data-testid="tido-env-badge"
      title={`TiDo API: ${cfg.base_url}\nDoména: *.${cfg.domain_suffix}${cfg.mock_enabled ? "\n(mock enabled)" : ""}`}
    >
      TiDo · {label}
    </div>
  );
}
